export default __webpack_public_path__ + "static/media/ic-irr-travelling.2dbd7488.svg";